class ResistantStarchBenefits extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
    }

    connectedCallback() {
        this.initSwiper();
        this.setupResizeListener();
    }

    disconnectedCallback() {
        this.cleanupSwiper();
        this.removeResizeListener();
    }

    initSwiper() {
        // Only initialize swiper on mobile screens
        if (window.innerWidth < 768) {
            const swiperElement = this.querySelector('.benefits-swiper');
            if (swiperElement && typeof Swiper !== 'undefined') {
                this.swiper = new Swiper(swiperElement, {
                    slidesPerView: 1.2,
                    spaceBetween: 20,
                    centeredSlides: false,
                    loop: true,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    pagination: {
                        el: '.benefits-pagination',
                        clickable: true,
                    }
                });
            }
        }
    }

    cleanupSwiper() {
        if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }
    }

    setupResizeListener() {
        this.resizeHandler = () => {
            if (window.innerWidth < 768) {
                // Destroy existing swiper if it exists
                this.cleanupSwiper();
                this.initSwiper();
            } else {
                // Clean up swiper on desktop
                this.cleanupSwiper();
            }
        };
        window.addEventListener('resize', this.resizeHandler);
    }

    removeResizeListener() {
        if (this.resizeHandler) {
            window.removeEventListener('resize', this.resizeHandler);
        }
    }
}

if (!customElements.get('resistant-starch-benefits')) {
    customElements.define('resistant-starch-benefits', ResistantStarchBenefits);
}
